<div class="container">
  <ae-page-step-nav></ae-page-step-nav>
  <div class="row">
    <div class="col-12 col-md-12 mx-auto mt-3">
      Bind Info forms here!
      <hr class="divider-dark" />
      <div class="button-row">
        <button type="button" class="btn btn-primary">
          Back
        </button>
        <button type="button" class="btn btn-primary">
          SAVE
        </button>
        <button type="button" class="btn btn-primary">
          Download Indication
        </button>
        <button type="button" class="btn btn-primary">
          Next
        </button>
      </div>
    </div>
  </div>
</div>
